'use client'

import CategoryCard from '@susu/headless-commerce/components/CMSPageSections/CategoryCard/CategoryCard'
import CategoryCarousel from '@susu/headless-commerce/components/CategoryCarousel/CategoryCarousel'
import type {
  CardCategoryContainerQuery,
  CardCategoryContainerQueryVariables,
} from '@susu/headless-commerce/gql/generated/cardCategoryContainer.operation'
import type {
  CardCategoryContainerTuxedoQuery,
  CardCategoryContainerTuxedoQueryVariables,
} from '@susu/headless-commerce/gql/generated/cardCategoryContainerTuxedo.operation'
import type { ImageWithText } from '@susu/headless-commerce/gql/generated/graphql'
import { useResizeObserver } from '@susu/headless-commerce/hooks/useResizeObserver'
import {
  isMobileScreen,
  isTabletScreen,
} from '@susu/headless-commerce/utils/responsiveUtils'
import { useCallback, useEffect, useState } from 'react'
import type { OperationResult } from 'urql/core'

import styles from './CategoryCards.module.scss'

export type CategoryCardsProps = {
  query:
    | OperationResult<
        CardCategoryContainerQuery,
        CardCategoryContainerQueryVariables
      >
    | OperationResult<
        CardCategoryContainerTuxedoQuery,
        CardCategoryContainerTuxedoQueryVariables
      >
}

export default function CategoryCards({ query }: CategoryCardsProps) {
  const cards: ImageWithText[] =
    ((
      query as OperationResult<
        CardCategoryContainerQuery,
        CardCategoryContainerQueryVariables
      >
    ).data?.cardCategoryContainer?.cardsCollection?.items as ImageWithText[]) ||
    []
  const [isMobile, setIsMobile] = useState<boolean>(false)

  const setupDevice = useCallback(() => {
    setIsMobile(isMobileScreen || isTabletScreen)
  }, [])

  useEffect(() => {
    setupDevice()
  }, [setupDevice])

  useResizeObserver(setupDevice)

  if (!cards) {
    throw new Error('CategoryCards: no Cards provided')
  }

  return isMobile && cards.length <= 4 ? (
    <div className={styles['category-cards']}>
      {cards.map((card) => (
        <CategoryCard key={card.title} card={card} />
      ))}
    </div>
  ) : (
    <CategoryCarousel>
      {cards.map((card) => (
        <CategoryCard key={card.title} card={card} />
      ))}
    </CategoryCarousel>
  )
}
